/**
 * Alert property container
 */
class Alert {
  constructor (title, description = null, priority = null, duration = null) {
    this.id = (new Date()).getTime()
    this.title = title
    this.description = description
    this.priority = priority
    this.duration = duration
  }

  isEphemeral () {
    return this.duration !== null
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/Alert.js